




























































































































































































































































































































































































































export default {
    name: 'IconSet',
};
